import { createSlice } from "@reduxjs/toolkit";

const initialDishwasherState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    dishwasherForEdit: undefined,
    lastError: null,
    currentTab: "accounts",
    message: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const dishwasherSlice = createSlice({
    name: "dishwashers",
    initialState: initialDishwasherState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error.clientMessage;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            state.message = null;

            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            state.message = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        // getDishwasherById
        dishwasherFetched: (state, action) => {
            state.actionsLoading = false;
            state.dishwasherForEdit = action.payload.dishwasherForEdit;
            state.floorPlans = action.payload.dishwasherForEdit.floorPlans;
            state.error = null;

        },
        // getDishwasherChart
        dishwasherChartFetched: (state, action) => {

            state.actionsLoading = false;
            state.dishwasherChart = action.payload.dishwasherChart;
            state.error = null;

        },
        // getDishwasherChart
        dishwasherHourlyChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.dishwasherChartHour = action.payload.dishwasherChartHour;
            state.error = null;

        },
        // getDishwasherChart
        dishwasherHourlyZoneChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.dishwasherChartHourZone = action.payload.dishwasherChartHourZone;
            state.error = null;

        },
        // get list data
        dishwashersFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
            state.dishwasherForEdit = undefined;
            state.floorPlans = undefined;
            state.dishwasherChart = undefined;
            state.dishwasherChartHour = undefined;
            state.dishwasherChartHourZone = undefined;
        },
        // createDishwasher
        dishwasherCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        // updateDishwasher
        dishwasherUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.message = action.payload.msgResponse;
        },
        // dishwasherDeleted
        dishwasherDeleted: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
            state.actionsLoading = false;
        },
        setMessage: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        setTab: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.currentTab = action.payload.tab;
        },
        userCreated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.message = action.payload.msgResponse;
        }

    }
});
